module.exports = __webpack_public_path__ + "media/images/card-tickets-82e3147eed18ca16d12ffabe2c05cd93.svg";